import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import sinisters from './modules/sinisters'

Vue.use(Vuex)

export default new Vuex.Store({
  /**
   * Assign the modules to the store
   */
  modules: {
    sinisters
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js